// extracted by mini-css-extract-plugin
export default {"formHeading":"sI-z","form":"tI-z","submitBtn":"uI-z","disabled":"vI-z","input":"wI-z","error":"xI-z","submitMsg":"yI-z","signIn":"zI-z"};